import API from 'utils/API'
import config from 'app/config'

export const fetchNews = (params) => (
  () => new Promise((resolve, reject) => (
        API.get(
            `/web/article${params || ''}`,
            { headers: { Authorization: `Bearer ${config.api_key}` } },
        ).then(
        (response) => {
            const { data, message } = response.data
            if (message === 'OK') {
            resolve(data)
            } else {
            reject(data)
            }
        },
        ).catch((err) => {
            reject(err.message) // eslint-disable-line no-console
        })
  ))
)

export const fetchNewsByCategory = (params) => (
  () => new Promise((resolve, reject) => (
        API.get(
            `/web/article${params || ''}`,
            { headers: { Authorization: `Bearer ${config.api_key}` } },
        ).then(
        (response) => {
            const { data, message } = response.data
            if (message === 'OK') {
            resolve(data)
            } else {
            reject(data)
            }
        },
        ).catch((err) => {
            reject(err.message) // eslint-disable-line no-console
        })
  ))
)

export const fetchCategories = params => (
    () => new Promise((resolve, reject) => (
      API.get(
        `/web/category${params || ''}`, 
        { headers: { Authorization: `Bearer ${config.api_key}` } }
    ).then(
        (response) => {
          const { data, message } = response.data
          if (message === 'OK') {
            resolve(data)
          } else {
            reject(data)
          }
        },
      ).catch((err) => {
        reject(err.message) // eslint-disable-line no-console
      })
    ))
)

export const fetchDetailNews = id => (
  () => new Promise((resolve, reject) => (
    API.get(
      `/web/article/${id}`, 
      { headers: { Authorization: `Bearer ${config.api_key}` } }
  ).then(
      (response) => {
        const { data, message } = response.data
        if (message === 'OK') {
          resolve(data)
        } else {
          reject(data)
        }
      },
    ).catch((err) => {
      reject(err.message) // eslint-disable-line no-console
    })
  ))
)

export const fetchCategoryDetail = id => (
  () => new Promise((resolve, reject) => (
    API.get(`/web/category/${id}`, { headers: { Authorization: `Bearer ${config.api_key}` } }).then(
      (response) => {
        const { data, message } = response.data
        if (message === 'OK') {
          resolve(data)
        } else {
          reject(data)
        }
      },
    ).catch((err) => {
      reject(err.message) // eslint-disable-line no-console
    })
  ))
)